import { manufacturerList } from "./Mocks/SelectSearch.mock";

export const payloadFilter = {
  sortField: "createdAt",
  sortOrder: "asc",
};

export const transferStatus = {
  pending: "Pending",
  delivering: "Delivering",
  delivered: "Delivered",
  cancel: "Cancel",
  returning: "Returning",
  returned: "Returned",
  confirmed: "Confirmed",
};

export const BatchStatus = {
  Pending: "Pending",
  Imported: "Imported",
  Draft: "Draft",
};

export const orderStatusFormatted = {
  all: "all",
  Pending: "Pending",
  WaitToProcess: "WaitToProcess",
  WaitToExport: "WaitToExport",
  ReadyToPick: "ReadyToPick",
  Delivering: "Delivering",
  Delivered: "Delivered",
  Finished: "Finished",
  Returning: "Returning",
  Lost: "Lost",
  ReturnedWaitToCheck: "ReturnedWaitToCheck",
  Returned: "Returned",
  ReturnFailed: "ReturnFailed",
  Canceled: "Canceled",
  Exported: "Exported",
  DeliveredFailed: "DeliveredFailed",
  ReturnRefund: "Return",
  Manual: "Manual",
  Exchange: "Exchange",
  New: "New",
  Imported: "Imported",
  Draft: "Draft",
  Done: "Done",
};

export const orderStatus = {
  Pending: "WaitToProcess",
  WaitToProcess: "WaitToExport",
  WaitToExport: "ReadyToPick",
  ReadyToPick: "Delivering",
  Delivering: "Delivered",
  Delivered: "Finished",
  Finished: "Finished",
  Returning: "ReturnedWaitToCheck",
  Lost: "Lost",
  ReturnedWaitToCheck: "Returned",
  Returned: "ReturnFailed",
  ReturnFailed: "ReturnFailed",
  Canceled: "Canceled",
  DeliveredFailed: "Returning",
  AllReturn: "AllReturn",
};

export const transferProviderStatus = {
  other: "Other",
  internal: "Internal",
};

export const userType = {
  staff: "Staff",
  sales: "Sales",
};

export const addressType = {
  home: "Home",
  office: "Office",
};

export const transferAddressType = {
  Home: "Nhà riêng",
  Office: "Công ty",
};

export const customerType = {
  individualCustomer: "Customer",
  business: "Company",
};

export const createUserType = {
  customer: "Customer",
  saleschannel: "SalesChannel",
};
export const CREATE_USER_TYPE_TRANSLATE = {
  Company: "Doanh nghiệp",
  Customer: "Khách hàng",
  SalesChannel: "Nhân viên kinh doanh",
};
export const orderTrackingType = {
  new: "New",
  removed: "Removed",
  remove: "Remove",
  export: "Export",
};

export const productGroupType = {
  retail: "Retail",
  manufacture: "Manufacture",
};

export const orderTrackingTypeTranslate = {
  New: "Xuất chuyển kho",
  Removed: "Xuất bỏ thủ công",
  Export: "Xuất sản xuất",
};

export const userRoleType = {
  admin: "Admin",
  superAdmin: "SuperAdmin",
  adminAccountant: "AdminAccountant",
  adminFactory: "AdminFactory",
  managerFactory: "ManagerFactory",
};

export const ORDER_PAYMENT_METHOD = {
  COD: "COD",
  TRANSFER: "Transfer",
};

export const SCAN_TYPE = {
  type: "type",
  scan: "scan",
};

export const CHECK_RETURN_PROD_STATUS = {
  all: "All",
  normal: "Normal",
  damaged: "Damaged",
  factory: "Factory",
  lostcode: "LostCode",
};

export const CHECK_ORDER_DELIVERY_ALL = {
  deliverryAll: "deliverryAll",
  Canceled: "Canceled",
  DeliveredFailed: "DeliveredFailed",
  BulkReturnProcessing: "BulkReturnProcessing",
};

/** /orders?tab=prepareBulk — soạn hàng hàng loạt */
export const CHECK_ORDER_BULK_PREPARE = {
  prepareBulk: "prepareBulk",
  bulkReturnProcessing: "BulkReturnProcessing",
};

export const PREPARE_BULK_TAB = {
  quickPrepare: "quickPrepare",
  createSlip: "createSlip",
};

export const DELIVERY_ALL_TAB = {
  prepare: "prepare",
  createOrderBill: "createOrderBill",
};

export const ORDER_STATUS_LIST = [
  "All",
  "Pending",
  "WaitToProcess",
  "WaitToExport",
  "ReadyToPick",
  "Delivering",
  "Delivered",
  "Finished",
  "Returning",
  "Lost",
  "ReturnedWaitToCheck",
  "Returned",
  "ReturnFailed",
  "Canceled",
  "Exported",
  "DeliveredFailed",
  "Return",
];

export const COMMOM_STATUS = {
  done: "Done",
  none: "None",
  error: "Error",
  None: "none",
  Processing: "Processing",
};

export const PRINT_SIZE = {
  a5: "A5",
  a6: "A6",
  width: "105mm",
  height: "148mm",
};

export const RETURN_REFUND_OPTIONS = {
  NEW: "New",
  EXCHANGE: "Exchange",
  RETURN: "Return",
  Remove: "Remove",
};

export const RETURN_CHANGE_TRANSLATE = {
  Exchange: "Đổi hàng",
  Return: "Trả hàng",
};

export const WAREHOUSE_OPTIONS_TRANSLATE = {
  New: "Xuất mới",
  Remove: "Xuất bỏ thủ công",
  Return: "Xuất bỏ theo đơn",
};

export const RETURN_REFUND_OPTIONS_TRANSLATE = {
  New: "Đơn mới",
  Exchange: "Đổi hàng",
  Return: "Trả hàng",
};

export const TRANSPORTATION_TYPE = {
  SELFDELIVERY: "SelfDelivery",
  PICKUP: "PickUp",
  COD: "COD",
};

export const ORDER_SOUCE_TYPE = {
  Return: "SalesChannel",
  Manual: "Manual",
};

export const ORDER_STATUS_TYPE = {
  Manual: "DeliveredFailed",
  all: undefined,
};

export const TRACKING_STATUS_TYPE = {
  Manual: "Returning",
};

export const ORDER_SOURCE_TYPE = {
  All: "All",
  Manual: "Manual",
  SalesChannel: "SalesChannel",
};
export const ORDER_SOURCE_TYPE_TRANSLATE = {
  Manual: "Kho",
  SalesChannel: "Kênh",
};
export const ORDER_TYPE = {
  ReturnRefund: "Return",
  Manual: "Return",
};

export const ORDER_CHANNEL = {
  Return: "SalesChannel",
  Manual: "Manual",
};

export const OUTPUT_FILES_TYPE = {
  PickingList: "PickingList",
  DeliveredReceipt: "DeliveredReceipt",
};

export const OUTPUT_FILES_TRANSLATE = {
  PickingList: "Phiếu đóng gói",
  DeliveredReceipt: "Phiếu xuất hàng",
};

export const ACTION_TYPE = {
  Create: "create",
  View: "view",
  Update: "update",
};

export const EXPORT_TYPE = {
  WarehouseExport: "WarehouseExport",
  WarehouseImport: "WarehouseImport",
  PickingList: "PickingList",
  /** Phiếu soạn hàng — đơn Chờ xuất hàng, tổng SL SP trước khi scan */
  PreparationList: "PreparationList",
  DeliveredReceipt: "DeliveredReceipt",
};

export const EXPORT_TYPE_TRANSLATETRANSLATE = {
  WarehouseExport: "Phiếu xuất kho",
  WarehouseImport: "Phiếu nhập kho",
  PickingList: "Phiếu xuất hàng",
  PreparationList: "Phiếu soạn hàng",
  DeliveredReceipt: "Phiếu đóng gói",
};

export const NAVIGATE_TYPE = {
  Next: "next",
  Prev: "prev",
  Reset: "reset",
};

export const DASHBOARD_STATISTIC = {
  totalNearExpire: "totalNearExpire",
  totalRequestRemove: "totalRequestRemove",
  totalTransfer: "totalTransfer",
  totalImport: "totalImport",
  totalRemove: "totalRemove",
  totalNearExpire: "totalNearExpire",
};

export const ORDER_STATUS_TRANSLATE = {
  all: "Tất cả",
  Pending: "Hoãn",
  WaitToProcess: "Chờ xác nhận",
  WaitToExport: "Chờ xuất hàng",
  ReadyToPick: "Chờ lấy hàng",
  Delivering: "Đang giao",
  Delivered: "Đã giao",
  Finished: "Hoàn thành",
  Returning: "Đang trả hàng",
  Lost: "Thất lạc",
  ReturnedWaitToCheck: "Trả hàng chờ kiểm tra",
  Returned: "Đã trả hàng",
  ReturnFailed: "Trả hàng thất bại",
  Canceled: "Hủy",
  Exported: "Đã xuất",
  DeliveredFailed: "Giao hàng thất bại",
  ReturnRefund: "Đổi hàng",
  Manual: "Thủ công",
  Exchange: "Đổi hàng",
  New: "Mới",
  Imported: "Đã nhập hàng",
};

export const printStatusType = {
  notFinished: false,
  finished: true,
};

export const WAREHOUSE_MANAGEMENT_TYPE = {
  HISTORY_OUT: "history-out",
  INVENTORY_OUT_PENDING: "inventory-out-pending",
  INVENTORY_OUT_REMOVE: "inventory-out-remove",
  HISTORY_IN: "history-in",
  INVENTORY_IN_PENDING: "inventory-in-pending",
};
export const WAREHOUSE_STATUS_TRANSLATE = {
  Pending: "Chờ xuất hàng",
  Exported: "Đã xuất hàng",
  Removed: "Y/c xuất bỏ",
  Imported: "Đã nhập kho",
  Rejected: "Từ chối",
  Canceled: "Hủy",
  Draft: "Nháp",
};

export const WAREHOUSE_TRANSFER_IN_TRANSLATE = {
  Pending: "Chờ nhập kho",
  Imported: "Đã nhập kho",
  Draft: "Nháp",
};
export const WAREHOUSE_MANAGEMENT_STATUS = {
  "history-out": undefined,
  "inventory-out-pending": "Pending",
  "inventory-out-remove": "Exported",
  "inventory-in-pending": "Pending",
};

export const WAREHOUSE_MANAGEMENT_TYPE_POST = {
  // "inventory-out-pending": "New",
  "inventory-out-remove": "Remove",
};
export const WAREHOUSE_TRANSFER_IN_TYPE = {
  New: "Nhập mới",
  Return: "Hoàn hàng",
  Remove: "Xuất bỏ",
};
export const SETTING_SYSTEM_TRANSLATE = {
  "transportation-provider": "Thiết lập ĐVVC",
  "transportation-provider-internal": "Thiết lập ĐVVC nội bộ",
};

export const SETTING_SYSTEM_TYPE = {
  "transportation-provider": undefined,
  "transportation-provider-internal": "Internal",
};
export const PAYMENT_METHOD = {
  EXPORT: "Export",
  IMPORT: "Import",
};
export const PAYMENT_METHOD_TRANSLATE = {
  COD: "COD",
  Transfer: "Chuyển khoản",
};

export const BATCH_TYPE_CREATE = {
  factory: "Factory",
  normal: "Normal",
};

export const BATCH_UPDATE_STATUS = {
  INITIAL: "Initialized",
  EXCHANGED: "Exchanged",
};

export const INVENTORY_EXPIRE = {
  "expired-date": 365,
};

export const WH_EXPORT_STATUS = {
  "inventory-out-pending": "Pending",
};
export const USER_TYPE = {
  Sales: "Sales",
  Staff: "Staff",
  Customer: "Customer",
  Company: "Company",
  SalesChannel: "SalesChannel",
};
export const USER_TYPE_TRANSLATE = {
  Customer: "KH cá nhân",
  Company: "Doanh nghiệp",
};

export const WAREHOUSE_TRANSFER_CREATE_TYPE = {
  CREATE: "Create",
  CREATE_CODE: "CreateCode",
};

export const UNIT_LIST = [
  {
    id: "g",
    label: "g (Gram)",
    type: ["g", "kg"],
  },
  {
    id: "kg",
    label: "kg (Kilogram)",
    type: ["g", "kg"],
  },
  {
    id: "ml",
    label: "mL (Mililít)",
    type: ["ml", "l"],
  },
  {
    id: "l",
    label: "L (Lít)",
    type: ["ml", "l"],
  },
  {
    id: "piece",
    label: "Cái",
    type: ["piece", "bottle", "combo"],
  },
  {
    id: "bottle",
    label: "Chai",
    type: ["piece", "bottle", "combo"],
  },
  {
    id: "combo",
    label: "Bộ",
    type: ["piece", "bottle", "combo"],
  },
];

export const UNIT_LIST_CONVERT = {
  kg: "Kg",
  g: "G",
  ml: "Ml",
  l: "L",
  piece: "Cái",
  bottle: "Chai",
  combo: "Bộ",
};

export const USER_ROLE_TYPE = {
  SUPER_ADMIN: "superadmin",
  ADMIN_ACCOUNTANT: "adminaccountant",
  ADMIN_FACTORY: "adminfactory",
  MANAGER_FACTORY: "managerfactory",
  STAFF_FACTORY: "stafffactory",
  ADMIN_WAREHOUSE: "adminwarehouse",
  MANAGER_WAREHOUSE: "managerwarehouse",
  STAFF_WAREHOUSE: "staffwarehouse",
  SALES: "sales",
};
